import { UnderConstruction } from '@luna/components/UnderConstruction';
import { HomeContent } from '@luna/screens/home/HomeContent';

export function AdminView() {
  return (
    <HomeContent title="Admin">
      <UnderConstruction />
    </HomeContent>
  );
}
